"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_CROP = exports.DEFAULT_HOTSPOT = void 0;
var DEFAULT_HOTSPOT = {
  x: 0.5,
  y: 0.5,
  height: 1,
  width: 1
};
exports.DEFAULT_HOTSPOT = DEFAULT_HOTSPOT;
var DEFAULT_CROP = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
};
exports.DEFAULT_CROP = DEFAULT_CROP;